import { defineQuery } from 'bitecs';
import { Position, Velocity, Wander } from '../world.js';

const wanderQuery = defineQuery([Position, Velocity, Wander]);

export function wanderSystem(world, delta) {
    const entities = wanderQuery(world);
    
    for (const eid of entities) {
        const wander = Wander;
        
        // Update timer
        wander.changeDirectionTimer[eid] += delta;
        
        // Check if it's time to change direction
        if (wander.changeDirectionTimer[eid] >= wander.changeDirectionInterval[eid]) {
            // Reset timer
            wander.changeDirectionTimer[eid] = 0;
            
            // Generate new random target position within a radius
            const radius = 100; // Maximum distance to wander
            const angle = Math.random() * Math.PI * 2;
            wander.targetX[eid] = Position.x[eid] + Math.cos(angle) * radius;
            wander.targetY[eid] = Position.y[eid] + Math.sin(angle) * radius;
        }
        
        // Calculate direction to target
        const dx = wander.targetX[eid] - Position.x[eid];
        const dy = wander.targetY[eid] - Position.y[eid];
        const distance = Math.sqrt(dx * dx + dy * dy);
        
        // Move towards target if not too close
        if (distance > 5) {
            const speed = wander.speed[eid];
            Velocity.x[eid] = (dx / distance) * speed;
            Velocity.y[eid] = (dy / distance) * speed;
        } else {
            // Stop when close to target
            Velocity.x[eid] = 0;
            Velocity.y[eid] = 0;
        }
    }
    
    return world;
} 